/* eslint no-multi-spaces: 0 */
/* eslint key-spacing: 0 */

import Vue from 'vue'
import {store} from '@/components/store'
import UserModel from './map.json'

import Intercom from '@/components/intercom'
import Salesforce from '@/components/salesforce'

const User = {
  loginUrl : 'about:blank',
  email    : ''
}

var sessionCheckTimer = null

function logout(noRedirect) {
  var app = global.app

  localStorage.removeItem('evedUser')
  localStorage.removeItem('evedUserCsrf')
  localStorage.removeItem('evedUserSettings')
  localStorage.removeItem('sessionSettings')
  localStorage.removeItem('eved-menu')
  localStorage.removeItem('eved-user')
  !noRedirect && app.$router.push({name: 'login'})
  if (app.$store) {
    app.$store.state.isLoggedIn = false
    app.$store.state.csrf = null
    app.$user.email = null
    app.$user.$ = null
    app.$notifications.removeAll()
  }
  store.commit('updateSessionValidity', false)

  !noRedirect && app.api.get(app.api.$.Logout)
  !noRedirect && app.api.get(app.api.$.logout)

  clearInterval(sessionCheckTimer)
  sessionCheckTimer = null

  Intercom.logout()
  Salesforce.logout()

  if (app.$routerHistory) {
    app.$routerHistory.save(['/login'])
  }

  if (window.self !== window.top) {
    if (window.top.app && window.top.app.$router) {
      window.top.app.$router.push('/login?expired')
    }
  }
}

function login(credentials) {
  var app = global.app

  if (credentials.sk) {
    return new Promise((resolve, reject) => {
      this.api.get(this.api.$.login + `?sk=${credentials.sk}`).then((res) => {
        resolve(res.data)
      }).catch((err) => {
        reject(err)
      })
    })
  }

  return new Promise((resolve, reject) => {
    app.api.post(app.api.$.login, credentials, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    }).then((res) => {
      resolve(res.data)
    }).catch((err) => {
      reject(err)
    })
  })
}

/**
 * Bind authentication endpoint response to $user
 *
 * @desc Response object {r}
 * @property {string} sk                  - user token
 * @property {object} user                - user details
 * @property {string} username            - user email
 * @property {Array.<string>} permissions - user permissions
 * @property {Object.<Object>} modules    - user modules
 * @property {string} type                - user type
 * @property {string} subscription        - user subcription
 * @property {string} invoicePrefHidden   - user has accepted e360 terms
 * @property {int} isDell                 - user is from company Dell with ERP
 * @property {(string)number} domain      - user market type id: 1=buyer, 2=buyer/seller, 3=seller
 *
 * @property {string} error               - authentication error
 */
function init(r, user, company) {
  this.$ = {}

  Object.keys(UserModel).forEach(key => {
    this.$[key] = user[key] = r ? r[UserModel[key]] : user[key]
  })

  this.$.data = this.$.data || {}
  this.$.settings = this.$.settings || company

  this.email = r ? r[UserModel.user].Email : user.email

  store.dispatch('check')
  // store.dispatch('ping')
}

export default {
  $: {
    get() { return User },
    default: User
  },

  logout,

  get: ()  => JSON.parse(global.localStorage.getItem('evedUser')) && {
    ...(JSON.parse(global.localStorage.getItem('evedUser')) || {}),
    settings: (JSON.parse(localStorage.getItem('sessionSettings')) || {}).CompanySettings || {},
    intercom_hash: (JSON.parse(localStorage.getItem('sessionSettings')) || {}).IntercomHMAC || ''
  },
  getCompanySettings: () => JSON.parse(global.localStorage.getItem('sessionSettings') || '{}').CompanySettings || {},
  set: (v) => global.localStorage.setItem('evedUser', JSON.stringify(v)),

  init() {
    /** Setup user on Vue instance */
    Object.defineProperty(Vue.prototype, '$user', {
      get() {
        var user    = this.$root.getUser || global.app.$user

        user.logout = logout
        user.login  = login
        user.init = function (response, authUser) { init.call(user, response, authUser) }
        user.sessionSettings = JSON.parse(localStorage.getItem('sessionSettings'))
        user.settings = user.sessionSettings && user.sessionSettings.CompanySettings || {}

        return user
      }
    })

    /** Init user with stored user */
    const authUser = JSON.parse(global.localStorage.getItem('evedUser'))
    const companySettings = (JSON.parse(localStorage.getItem('sessionSettings')) || {}).CompanySettings || {}

    if (authUser && authUser.token) {
      init.call(User, null, authUser, companySettings)

      /** Once set up, start verifying session validity */
      // store.dispatch('ping')
    }
  },

  /**
   * Check token validity
   * at a set interval (10 minutes)
   */
  checkSession(commit) {
    const api = global.app.api
    const intervalToCheck = 10 * 60 * 1000

    let expires = global.app.$user.sessionSettings && global.app.$user.sessionSettings.Token
      ? getTokenExpiration(global.app.$user.sessionSettings.Token)
      : null

    if (!expires) {
      return
    }

    if (store.state.isLoggedIn) {
      store.commit('updateSessionValidity', true)
      sessionCheckTimer = setInterval(() => { ping(commit) }, intervalToCheck / 2)
    }

    function ping (commit) {
      const threshold = global.moment().add(intervalToCheck, 'millisecond')

      if (store.state.isLoggedIn && expires && expires.isBefore(threshold)) {
        api.post(api.$.settings.my.renew, null, {
          headers: {
            Authorization: `Bearer ${global.app.$user.sessionSettings.Token}`
          }
        }).then(response => {
          if (response) {
            store.commit('updateSessionValidity', true)

            global.localStorage.setItem('sessionSettings', JSON.stringify({
              ...global.app.$user.sessionSettings,
              Token: response.data.Token
            })
            )
            expires = getTokenExpiration(response.data.Token)
          } else {
            store.commit('updateSessionValidity', false)
          }
        }).catch(() => {
          store.commit('updateSessionValidity', false)
        })
      } else {
        //
      }
    }

    function getTokenExpiration(token) {
      if (!token) {
        return null
      }
      const base64Url = token.split('.')[1]
      const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/')

      const jsonPayload = decodeURIComponent(
        atob(base64).split(``)
          .map(c => '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2)
          )
          .join('')
      )

      const decodedToken = JSON.parse(jsonPayload)

      return global.moment(decodedToken.exp * 1000)
    }
  }
}



// WEBPACK FOOTER //
// ./src/core/user/index.js